import React from "react";

const Footer = () => {
    return (
        <div className="footer">
          <footer>
            <p>Copyright © 2023 Jake Sadowski</p>
          </footer>
        </div>
      );
    }

    export default Footer;